import type {ReactElement} from 'react';
import {SkeletonBrick, SkeletonBrickTheme} from '@Components/skeleton-brick';
import type {ButtonGroupSkeletonProps} from './button-group-skeleton.types';
import styles from './button-group-skeleton.module.scss';

export function ButtonGroupSkeleton({buttonWidths}: ButtonGroupSkeletonProps): ReactElement {
  return (
    <div className={styles.buttonGroup}>
      {buttonWidths.map((width, index) => (
        <SkeletonBrick key={`${width}-${index}`} className={styles.button} width={width} radius={'8px'} theme={SkeletonBrickTheme.LIGHT} />
      ))}
    </div>
  );
}
